import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/projects/Civi_Circle_Admin/components/ui/card";
import { ScrollArea } from "@/projects/Civi_Circle_Admin/components/ui/scroll-area";
import {
  Users,
  Calendar,
  DollarSign,
  Heart,
  Building2,
  User,
} from "lucide-react";

interface Activity {
  user_name?: string;
  activity_type?: string;
  activity_title?: string;
  created_by?: string;
}

interface RecentActivityProps {
  activities?: Activity[];
}

// Helper to get icon based on activity type
const getActivityIcon = (activityType?: string) => {
  const type = activityType?.toLowerCase() ?? "";
  if (type.includes("member") || type.includes("user")) {
    return <Users className="h-5 w-5 text-muted-foreground" />;
  }
  if (type.includes("event")) {
    return <Calendar className="h-5 w-5 text-muted-foreground" />;
  }
  if (type.includes("donation")) {
    return <DollarSign className="h-5 w-5 text-muted-foreground" />;
  }
  if (type.includes("volunteer")) {
    return <Heart className="h-5 w-5 text-muted-foreground" />;
  }
  if (type.includes("organization") || type.includes("org")) {
    return <Building2 className="h-5 w-5 text-muted-foreground" />;
  }
  // Default icon
  return <User className="h-5 w-5 text-muted-foreground" />;
};

export function RecentActivity({ activities = [] }: RecentActivityProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[300px] pr-4">
          <div className="space-y-4">
            {activities.length === 0 ? (
              <div className="py-4 text-center text-sm text-muted-foreground">
                No recent activity
              </div>
            ) : (
              activities.map((activity, index) => (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={`activity-${index}-${activity.created_by ?? ""}`}
                  className="flex gap-4 border-b pb-4 last:border-0"
                >
                  <div className="flex-shrink-0">
                    {getActivityIcon(activity.activity_type)}
                  </div>
                  <div className="flex-1 space-y-1">
                    <p className="text-sm font-medium leading-none">
                      {activity.activity_title ?? "Activity"}
                    </p>
                    {activity.user_name && (
                      <p className="text-xs text-muted-foreground">
                        {activity.user_name}
                      </p>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
